export default (elements, callback) => {
  const options = {
    root: null,
    rootMargin: '0px',
    threshold: 0.05,
  };

  const func = (entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const { target } = entry;
        callback(target);
        target.classList.add('is-showed');
        observer.unobserve(target);
      }
    });
  };

  const observer = new IntersectionObserver(func, options);
  elements.forEach((target) => {
    observer.observe(target);
  });
};
